// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__1d3o-","content":"RecentSearches_content__1S8VD"};